<template>
    <poverty-visualization :charts="charts" :area-chart="areaChart" :line-chart="lineChart" :title="title" :y-domain="yDomain"></poverty-visualization>
</template>
<script>
    import PovertyVisualization from './PovertyVisualization';
    export default{
        data: function(){
            return {
                title: 'Tasa de Afiliaciones a Sistema de Salud',
                yDomain: [0,100],
                charts: [
                    {
                        id: 'zona',
                        title: 'Zonas Urbanas y Rurales',
                        file: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vSgtvHsDYA25QJ3faQ2Zi0EudOu2igcEn5kcQRI9Db2i-uB79NXKWE87ffCdhurE7awW2u5IJASzu5H/pub?gid=0&single=true&output=csv',
                        countryFile: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vTazQEh0U2qt61qSKuCOeOZLd3pASPh15XFm5uYwWRVPFAexamvcvv3aXwEEv_ocsLpxxnL4hdrdqs5/pub?gid=0&single=true&output=csv',
                        dimensions: ['nom_reg','zona']
                    },
                    {
                        id: 'sexo',
                        title: 'Género',
                        file: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vSQ-PXTWbY__N-C_QY6uD87mafQlFXhPt3px_0rliQPsyosQekl0vAlQ-9XPr-vcr80D3Y4hyO1tlXK/pub?gid=0&single=true&output=csv',
                        countryFile: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vTa9jqo7l506SLqxl0puUCTxFZYKMrIUoQ6_ZhXE2jCx7wjeyMsX2bsVbVVhMH6feybkYNsHouREHtZ/pub?gid=0&single=true&output=csv',
                        dimensions: ['nom_reg','sexo']
                    },
                    {
                        id: 'pueb_indig',
                        title: 'Pueblos Indigenas',
                        file: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vR6knqwes_o4kf5qUmOyD7udJKTSGPcPLipUJzpmAl6zaebURgxEF_T7Q4AixinHzBnrCIJvq39rzgE/pub?gid=0&single=true&output=csv',
                        countryFile: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vSQa1JiN1ciBZNcttdIm3hIIQsqT3Cx_zip09fkVZi9hjDSlsOiz0C_Xtuw1YTzm8Qq9s2tQP2nXJ1o/pub?gid=0&single=true&output=csv',
                        dimensions: ['nom_reg','pueb_indig']
                    },
                    {
                        id: 'migrantes',
                        title: 'Migrantes',
                        file: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vSrnFDx4kDcgl7yK7zpepklk32pTM6GDXkzUxVJxrE39-YgxLvhzINCsiaRqMaiNSeHh0xbyJHdome_/pub?gid=0&single=true&output=csv',
                        countryFile: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vQlc6LqXiCJXl6zzLIoyvqIE6AMXmpoxmHt9XOFl5vnoeoQQJHbk6DjOSAwQnMGdwproJQ_tNgkTvDg/pub?gid=0&single=true&output=csv',
                        dimensions: ['nom_reg','migrantes']
                    },
                    {
                        id: 'edades',
                        title: 'Rango Etario',
                        file: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vRPoFVhjTFtqjJvSVX2N2k5mrUanyX6mqn6slKpQ5FqRQ0C3YCoAzuGtJm4pkurs9NIc1HgOOIjn6LG/pub?gid=0&single=true&output=csv',
                        countryFile: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vTWGFCZoEdjNn0njHUrAFUaHIwpajLJkuTrGcdS7mWcKO-CNy-9mi8qxggUI0ksBB6iEON8f40ukiRP/pub?gid=0&single=true&output=csv',
                        dimensions: ['nom_reg','edades']
                    },
                    {
                        id: 'quintil',
                        title: 'Quintiles',
                        file: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vQmOgv3K64OesHBbg8vOSB2RSz-QpgIQqOJhv-U_MB__6kuGim_ew1MZa7sucsfqGC77KFn8HZUgHI0/pub?gid=0&single=true&output=csv',
                        countryFile: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vQAnR2fXwrUbI90bVYeKbRn9IlRigZMiN8ut6NO89S4FIuG9RJQlO4D5ECC0aQe2OLDsc6nusbkXOHX/pub?gid=0&single=true&output=csv',
                        dimensions: ['nom_reg','quintil']
                    }
                ],
                areaChart:{
                    file: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vTddAqgSEbr1TP7ftThqQm77rG_LwUt0lVO7-ID9Qt2TQH2BVmgl-B1Iv5BE3MU7VZldhpPVv_0YP2R/pub?gid=0&single=true&output=csv'
                },
                lineChart:{
                    file: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vSYa4_rjCTwwOkXpyF5mz1K4zdGU5avZt4AZWWdSdbDASGwAKnXSbzRwWF1ebrz8lbtai1gyQsfwBpM/pub?gid=0&single=true&output=csv'
                }
            }
        },
        components: {
            PovertyVisualization
        }

    }
</script>


// WEBPACK FOOTER //
// src/js/Components/Visualizations/HealthAffiliationVisualization.vue